// extracted by mini-css-extract-plugin
module.exports = {"popup":"popupmvp_popup__jBxOQ","scroll_view":"popupmvp_scroll_view__lfEYw"};